module.exports = __webpack_public_path__ + "img/facebook.8f5ce275.png";